export default __webpack_public_path__ + "static/media/home_02_active.acbf2aa3.png";